import { services as auth } from '@/modules/auth';
import { services as mfa } from '@/modules/mfa';
import { services as profile } from '@/modules/profile';

export default {
    auth,
    mfa,
    profile
}